module.exports = __webpack_public_path__ + "img/star-gray.48184f7c.svg";